module.exports = __webpack_public_path__ + "static/media/oseberg_full_text_search_logo.a2e41258.svg";